/**
 * FAQ Script - Tab switching, accordion, and search functionality
 * Only runs on FAQ pages
 */
document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on an FAQ page
    if (!window.location.pathname.includes('faq-questions-frequemment-posees')) {
        return;
    }

    const navButtons = document.querySelectorAll('.nav-btn');
    const faqSections = document.querySelectorAll('.faq-section');
    const faqQuestions = document.querySelectorAll('.faq-question');
    const searchInput = document.getElementById('searchInput');

    // Tab Switching
    navButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const targetSection = btn.getAttribute('data-section');
            if (!targetSection) return;
            
            navButtons.forEach(b => b.classList.remove('active'));
            faqSections.forEach(s => s.classList.remove('active'));
            
            btn.classList.add('active');
            const targetEl = document.getElementById(targetSection);
            if (targetEl) targetEl.classList.add('active');
        });
    });

    // Accordion Toggling
    faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
            const answer = question.nextElementSibling;
            if (!answer) return;
            
            // Optional: Close other open questions in the same section
            const currentSection = question.closest('.faq-section');
            if (currentSection) {
                currentSection.querySelectorAll('.faq-question').forEach(q => {
                    if (q !== question) {
                        q.classList.remove('active');
                        const qAnswer = q.nextElementSibling;
                        if (qAnswer) qAnswer.classList.remove('active');
                    }
                });
            }

            question.classList.toggle('active');
            answer.classList.toggle('active');
        });
    });

    // Search Filtering
    if (searchInput) {
        searchInput.addEventListener('input', (e) => {
            const target = e.target;
            if (!target || !(target instanceof HTMLInputElement)) return;
            
            const term = target.value.toLowerCase().trim();
            const faqItems = document.querySelectorAll('.faq-item');

            if (term === '') {
                // Restore tab behavior if search is cleared
                faqItems.forEach(item => {
                    if (item instanceof HTMLElement) {
                        item.style.display = 'block';
                    }
                });
                const faqNav = document.querySelector('.faq-nav');
                if (faqNav instanceof HTMLElement) {
                    faqNav.style.display = 'flex';
                }
                
                // Reset to active tab
                const activeBtn = document.querySelector('.nav-btn.active');
                if (activeBtn) {
                    const targetSection = activeBtn.getAttribute('data-section');
                    if (targetSection) {
                        faqSections.forEach(s => s.classList.remove('active'));
                        const targetEl = document.getElementById(targetSection);
                        if (targetEl) targetEl.classList.add('active');
                    }
                }
                return;
            }

            // Hide navigation tabs during search
            const faqNav = document.querySelector('.faq-nav');
            if (faqNav instanceof HTMLElement) {
                faqNav.style.display = 'none';
            }
            
            faqItems.forEach(item => {
                const questionEl = item.querySelector('.faq-question');
                const answerEl = item.querySelector('.faq-answer');
                
                if (!questionEl || !answerEl) return;
                
                const questionText = questionEl.textContent?.toLowerCase() || '';
                const answerText = answerEl.textContent?.toLowerCase() || '';
                
                if (item instanceof HTMLElement) {
                    if (questionText.includes(term) || answerText.includes(term)) {
                        item.style.display = 'block';
                        // Show parent section to make item visible
                        const parentSection = item.closest('.faq-section');
                        if (parentSection) parentSection.classList.add('active');
                    } else {
                        item.style.display = 'none';
                    }
                }
            });

            // Hide sections that have no matching visible items
            faqSections.forEach(section => {
                const items = section.querySelectorAll('.faq-item');
                const visibleItems = Array.from(items).filter(i => {
                    return i instanceof HTMLElement && i.style.display === 'block';
                });
                if (visibleItems.length === 0) {
                    section.classList.remove('active');
                } else {
                    section.classList.add('active');
                }
            });
        });
    }
});